import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { LuggageCategory } from 'src/app/models/LuggageCategory.model';
import { PassengerChangeTimeVector, PassengerChangeTimeVectorValue } from 'src/app/models/PassengerChangeTimeVector.model';
import { GridData } from 'src/app/matrix-component/grid-list/gridData.model';
import { IdValue } from 'src/app/matrix-component/grid-list/idvalue.model';
import { CloneService } from 'src/app/services/clone.service';
import { StepsAmount } from 'src/app/models/StepsAmount.model';

@Component({
  selector: 'app-passenger-change-time-vector',
  templateUrl: './passenger-change-time-vector.component.html',
  styleUrls: ['./passenger-change-time-vector.component.scss']
})
export class PassengerChangeTimeVectorComponent implements OnInit {

  constructor(private _formBuilder: FormBuilder,private cloneService:CloneService) { }


  ngOnInit() {
    this.form = this.parentForm;
    this.form.addControl('passengerChangeTimeVector', this._formBuilder.array([]));
    this.form.setControl('passengerChangeTimeVector', this.asFormGroup(this.data));
    this.lascCtrl = this.form.get('passengerChangeTimeVector');
    this.lascCtrl= this.lascCtrl.get('values');
    this.data.values =  this.lascCtrl.value as PassengerChangeTimeVectorValue[];
    this.gridData_1=this.ConvertData(1);
    this.gridData_2=this.ConvertData(2);
  }
  asFormGroup(o: PassengerChangeTimeVector): FormGroup {
    const fg = new FormGroup({
      id: new FormControl(o.id, Validators.required),
      regionId: new FormControl(o.regionId, Validators.required),
      values: new FormControl(o.values, Validators.required)
    });
    return fg;
  }
  @Input('form') parentForm: FormGroup;
  @Input('data') data: PassengerChangeTimeVector;
  @Input('colHeaders') colHeaders: StepsAmount[];
  @Input('rowHeaders') rowHeaders: LuggageCategory[];
  @Input('isEditable') isEditable: boolean;
  @Input('timeType') timeType: boolean;
  gridData_1: GridData=new GridData();
  gridData_2: GridData=new GridData();
  form: FormGroup;
  lascCtrl;

  ConvertData(timeTypeId:number): GridData {
    // for (let i = 0; i < this.data.values.length; i++) {
    //   const element = this.data.values[i];
    //   if(element.timeTypeId===timeTypeId)
    //   {
    //     element.ageGenderId+=1;
    //   }
    // }

    let rowHeaders: IdValue[] = [];
    for (let i = 0; i < this.rowHeaders.length; i++) {
      const headerEntry = this.rowHeaders[i];
      rowHeaders.push(new IdValue(headerEntry.id,headerEntry.name));
    }

    let colHeaders: IdValue[] = [];
    for (let i = 0; i < this.colHeaders.length; i++) {
      const headerEntry = this.colHeaders[i];
      colHeaders.push(new IdValue(headerEntry.id,headerEntry.name));
    }
    let grid: GridData = new GridData();
    grid.colHeaders = colHeaders;
    grid.rowHeaders = rowHeaders;
    grid.matrix = this.data.values.filter(f=>f.timeTypeId===timeTypeId);
    grid.colProp = 'stepsAmountId';
    grid.rowProp = 'luggageCategoryId';
    grid.switchColWithRow = false;
    return grid;
  }
  save()
  {
    if(this.lascCtrl !== null)
    {
      this.lascCtrl.patchValue(this.data.values);
    }
  }
}
